import Home from "./home/index";
import Case from "./case/index";
import Product from "./product/index";
import About from "./about/index";

const CN = {
  Language: {
    type: "中文",
  },
  Home: Home.CN,
  Case: Case.CN,
  Product: Product.CN,
  About: About.CN,
};

const EN = {
  Language: {
    type: "English",
  },
  Home: Home.EN,
  Case: Case.EN,
  Product: Product.EN,
  About: About.EN,
};

export default {
  CN,
  EN,
};



// WEBPACK FOOTER //
// ./src/language/index.js